import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createSession } from "services/Session.services";

export function useNewPatient() {
  const navigate = useNavigate();

  const createNewSessionMutation = useMutation({
    mutationFn: createSession,
    onSuccess: (data) => {
      navigate(`/session/${data.id}`);
    },
  });

  const handleCreateNewSession = () => {
    createNewSessionMutation.mutate({
      firstName: "",
      lastName: "",
      birthDate: undefined,
      address: "",
      phone: "",
      identificationNumber: "",
      email: "",
    });
  };

  return {
    handleCreateNewSession,
  };
}
